"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
let AddWebPagesGroupManager = class extends Vue {
  constructor() {
    super(...arguments);
    this.choosedGroupId = "";
    this.groupLists = [];
    this.groupTree = [];
    this.groupProps = {
      label: "name",
      children: "children"
    };
    this.controller = [];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getResourceGroupTree();
    });
  }
  getResourceGroupTree() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v1/web-resource-groups`
        );
        let arr = response.data.datas;
        let new_arr = [];
        for (let item of arr) {
          let data = {
            "id": item.id,
            "createdTime": item.createdTime,
            "isEdit": false,
            "model": item.model,
            "name": item.name,
            "updatedTime": item.updatedTime,
            "type": item.type,
            "parentId": item.parentId,
            "children": []
          };
          new_arr.push(data);
        }
        this.groupLists = new_arr;
        this.handleGroupListChangeTree(this.groupLists);
        this.$nextTick(function() {
          this._webResourceGroupTree.setCurrentKey(this.choosedGroupId);
          this.checkGrid();
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //编辑
  editGroupName(data) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth/api/v1/web-resource-groups/${data.id}`, {
          "name": data.name
        });
        data.isEdit = false;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //删除
  deleteGroupName(data) {
    return __async(this, null, function* () {
      try {
        yield this.$confirm(
          this.$t("safemanager.web_resource.group.delete_content", {
            name: data.name
          }),
          this.$t("vdcontainer.hint"),
          {
            confirmButtonText: this.$t("vdcontainer.determine"),
            cancelButtonText: this.$t("vdcontainer.cancel"),
            type: "warning"
          }
        );
        yield API.delete(`api://base.auth/api/v1/web-resource-groups/${data.id}`);
        yield this.getResourceGroupTree();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  checkGrid() {
    this.$emit("groupChanged", { id: this.choosedGroupId });
  }
  changeEdit(data) {
    data.isEdit = true;
  }
  closeEdit(data) {
    data.isEdit = false;
  }
  handleGroupListChangeTree(list) {
    let arr = [];
    for (let item of list) {
      let data = {
        "id": item.id,
        "createdTime": item.createdTime,
        "isEdit": false,
        "model": item.model,
        "name": item.name,
        "updatedTime": item.updatedTime,
        "type": item.type,
        "parentId": item.parentId,
        "children": []
      };
      if (data.parentId === "root") {
        this.getTrees(data);
        arr.push(data);
      }
    }
    this.groupTree = arr;
  }
  getTrees(item) {
    item.children = [];
    for (let data of this.groupLists) {
      if (data.parentId === item.id) {
        if (this.choosedGroupId === "") {
          this.choosedGroupId = data.id;
        }
        item.children.push(data);
      }
    }
  }
  handleCheckChange(data, dataNode) {
    return __async(this, null, function* () {
      this.choosedGroupId = data.id;
      this.$emit("groupChanged", { id: data.id });
    });
  }
  refresh() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          "api://base.auth/api/v1/web-resource-groups"
        );
        this.groupLists = response.data.datas;
        this.handleGroupListChangeTree(this.groupLists);
        this.$nextTick(function() {
          this._webResourceGroupTree.setCurrentKey(this.choosedGroupId);
          this.checkGrid();
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  openGroupManager() {
    this.$emit("openGroupDialog");
  }
};
__decorateClass([
  PropSync("gridController")
], AddWebPagesGroupManager.prototype, "_gridController", 2);
__decorateClass([
  Ref("web-resrouce-group-tree")
], AddWebPagesGroupManager.prototype, "_webResourceGroupTree", 2);
AddWebPagesGroupManager = __decorateClass([
  Component({
    components: {}
  })
], AddWebPagesGroupManager);
export {
  AddWebPagesGroupManager as default
};
